import { screeningAction } from '../../actions/constant';

const { GET_SCREENING_TYPE_SUCCESS, GET_SCREENING_TYPE_FAILURE } = screeningAction;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
};

export const getScreeningTypeReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_SCREENING_TYPE_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
      };
    }

    case GET_SCREENING_TYPE_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };

    default:
      return state;
  }
};
